import React, { useState, setGlobal, getGlobal, useEffect } from 'reactn';
import {useParams} from 'react-router-dom';
import { Radio, Tabs, Row } from 'antd';
import { firestore, useFirestore } from 'reactfire';
import Ear from './Ear/Ear';
import Nasal from './Nasal/Nasal';
import OralCavity from './OralCavity/OralCavity';
import ThroatLarynxHypopharynx from './ThroatLarynxHypopharynx/ThroatLarynxHypopharynx';

const ChiefComplaints = () => {

    let { appointmentId } = useParams();
    let firestore = useFirestore();

    const [location, setLocation] = useState('Ear');

    const changeLocation = (event) => {
        setLocation(event.target.value);
    }


    useEffect(() => {
        // console.log('im running this many times', getGlobal().hasFetchedChiefComplaints);
        getChiefComplaints(); 
    }, [getGlobal()]);

    const getChiefComplaints = () => {
        setGlobal({hasFetchedChiefComplaints: false});
        let records = [];
        firestore.collection("ChiefComplaints").where("appointment_id", "==", appointmentId).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
                console.log('DOC IS : ', doc.data())
            });
            //console.log('DOC is ',records[0].data);

            
           
            // console.log(records.length, records );

            // setapmt(records.length !== 0 ? records[0].data : null);
            // setLoader(false);
            // console.log(records[0].location, getGlobal().location, 'this is cheif comp');
        }).finally(() => {
            setGlobal({ChiefComplaints_location: records.length > 0 ? records[0].data.ChiefComplaints_location : getGlobal().ChiefComplaints_location});
            
            setGlobal({ChiefComplaints_location_appointment_id: records.length > 0 ? records[0].data.appointment_id : getGlobal().ChiefComplaints_location_appointment_id});
            setGlobal({ChiefComplaints_location_id: records.length > 0 ? records[0].id : null});
            setGlobal({hasFetchedChiefComplaints: true});
        })
    }

    const documentHasSaved = () => {
        getChiefComplaints();
    }


        const { TabPane } = Tabs;

        function earTabs(key) {
        console.log(key);
        }

        
 

    return (
        <div>
         <React.Fragment>
            <Radio.Group defaultValue={'Ear'} onChange={changeLocation} buttonStyle="solid" size="large">
                <Radio.Button value={'Ear'}>Ear</Radio.Button>
                <Radio.Button value={'Nasal'}>Nasal</Radio.Button>
                <Radio.Button value={'Oral Cavity'}>Oral Cavity</Radio.Button>
                <Radio.Button value={'ThroatLarynxHypopharynx'}>Throat/Larynx/Hypopharynx</Radio.Button>
           </Radio.Group>

            {location === 'Ear' ? 
                <Ear hasSaved={documentHasSaved} EarData={getGlobal().ChiefComplaints_location}/>
            : ''
            }

            {location === 'Nasal' ? 
                <Nasal hasSaved={documentHasSaved} EarData={getGlobal().ChiefComplaints_location}/>
            : ''
            }

            {location === 'Oral Cavity' ?
                <OralCavity hasSaved={documentHasSaved} EarData={getGlobal().ChiefComplaints_location}/>
            : ''
            }

            {location === 'ThroatLarynxHypopharynx' ?
               <ThroatLarynxHypopharynx hasSaved={documentHasSaved} EarData={getGlobal().ChiefComplaints_location}/>
            : ''
            }


         </React.Fragment>

        </div>
    );
}

export default ChiefComplaints;
